import { Component, OnInit,Output,EventEmitter, Input, forwardRef } from '@angular/core';
import { FormControl } from '@angular/forms';

import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor } from '@angular/forms';

import { RootService } from '../../service/root.service';

@Component({

    selector: 'aFormCurrency,[aFormCurrency]',
    templateUrl: './aFormCurrency.component.html',
    styleUrls: ['./aFormCurrency.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: AFormCurrencyComponent, multi: true }
    ]
})
export class AFormCurrencyComponent implements OnInit, ControlValueAccessor {
    @Input() id;
    @Input() label;
    @Input() placeholder;
    @Input() required;
    @Input() cClass;
    @Input() icon;
    @Input() disabled;
    @Output() changeValue: EventEmitter<any> = new EventEmitter();
    value;
    formControl;
    _onChange = (value: any) => { 
        this.changeValue.emit(+value);
    };

    registerOnChange(fn) {
        this._onChange = fn;
    }

    registerOnTouched() { }
    writeValue(value: any) {
        this.value = value;
    }

    constructor(public rootService:RootService) {

    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/component/aFormCurrency/aFormCurrency.component.ts